var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/components/Popover/Popover.styled.ts";
import styled, { css } from 'styled-components';
import { Popover as PopoverMiu, popoverClasses } from '@mui/material';
import { styled as mStyled } from '@mui/styles';
import { ScrollBar } from '../../../ScrollBar';
export const PopoverStyled = mStyled(PopoverMiu)(({
  paperStyles,
  spaceBottomLessMin
}) => ({
  [`${popoverClasses.root}`]: {
    boxShadow: '0px 5px 10px rgba(53, 60, 96, 0.15)',
    borderRadius: '4px',
    margin: spaceBottomLessMin ? '-3px 0 0 0' : '3px 0 0 0',
    ...paperStyles
  }
}));
export const Content = styled(ScrollBar)`
  width: 100%;
  overflow-y: overlay;
  overflow-x: hidden;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 5px 10px rgba(53, 60, 96, 0.15);
  position: relative;

  ${props => props.additionalStyles}

  ${props => props.maxHeight && css`
      max-height: ${props.maxHeight}px;
    `}
`;